/**
 * Regras de classificação da fila do Painel de Monitoramento de PS (PS Adulto x PS Infantil).
 *
 * Regra padrão (todas as unidades):
 *  - Triagem e Cadastro (identificador Totem): fila infantil quando o totem contém "INFANTIL".
 *  - Demais processos (identificador Especialidade): fila infantil quando a especialidade é "PEDIATRIA".
 *
 * CC-856: no HSLN (db-orcl-hsl / empresa 4) o fluxo de Ginecologia/Obstetrícia opera na mesma ala
 * do atendimento pediátrico, portanto seus atendimentos passam a ser monitorados na fila do PS Infantil
 * em todos os processos do painel. Nas demais unidades a regra padrão é mantida.
 */

// Unidades (base -> empresas do MV) em que Ginecologia/Obstetrícia é monitorada na fila do PS Infantil.
const UNIDADES_GINECO_OBSTETRICIA_INFANTIL = {
  'db-orcl-hsl': [4], // HSLN - Hospital Santa Lúcia Norte
};

// Termos buscados (like %GINECO% ou like %OBSTE%) no totem ou na especialidade.
const TERMOS_GINECO_OBSTETRICIA = ['GINECO', 'OBST'];

// Processos identificados pelo Totem (DESCRICAOITEM); os demais são identificados pela Especialidade.
const PROCESSOS_TOTEM = [1, 2];

let migrarGinecoObstetricia = false;

/**
 * Define a unidade em exibição. Deve ser chamada uma única vez ao entrar na tela,
 * antes da montagem dos dados dos cards.
 */
export const configurarRegraFilaPS = ({ base, company }) => {
  migrarGinecoObstetricia = (UNIDADES_GINECO_OBSTETRICIA_INFANTIL[base] ?? []).includes(Number(company));
};

const isGinecoObstetricia = (texto) => {
  const valor = String(texto ?? '').toUpperCase();
  return TERMOS_GINECO_OBSTETRICIA.some((termo) => valor.includes(termo));
};

/**
 * Indica se o paciente deve ser monitorado na fila do PS Infantil no processo (tipoCard) informado.
 */
export const isFilaInfantil = (tipoCard, item) => {
  if (PROCESSOS_TOTEM.includes(Number(tipoCard))) {
    const totem = String(item?.DESCRICAOITEM ?? '');
    return totem.includes('INFANTIL') || (migrarGinecoObstetricia && isGinecoObstetricia(totem));
  }

  const especialidade = String(item?.DESCRICAOESPECIALIDADE ?? '');
  return especialidade === 'PEDIATRIA' || (migrarGinecoObstetricia && isGinecoObstetricia(especialidade));
};
